import { FilterType } from "@studyportals/omnisearch-interfaces";
import { FilterMapper } from "@app/routing/mappers/FilterMapper";
import { DegreeTypeFilterValue } from "@studyportals/search-api-interface";
import {IExtendedWithPortalTypeFilterValue} from "@app/routing/mappers/IExtendedWithPortalTypeFilterValue";
import {PortalType} from "@studyportals/domain-client";
import { SearchType } from "@domain/enums/SearchType";

export class DegreeTypeFilterMapper extends FilterMapper {
	public filterType: FilterType = FilterType.DEGREE_TYPE;
	public isMultiSelect = true;
	private static instance: DegreeTypeFilterMapper;

	protected values: IExtendedWithPortalTypeFilterValue[] = [
		{ id: DegreeTypeFilterValue.MSC, virtualPath: 'msc', name: 'M.Sc. Master of Science', shortName: 'M.Sc.', portalTypes: [PortalType.MASTER] },
		{ id: DegreeTypeFilterValue.MA, virtualPath: 'ma', name: 'M.A. Master of Arts', shortName: 'M.A.', portalTypes: [PortalType.MASTER] },
		{ id: DegreeTypeFilterValue.MBA, virtualPath: 'mba', name: 'M.B.A. Master of Business Administration', shortName: 'M.B.A.', portalTypes: [PortalType.MASTER] },
		{ id: DegreeTypeFilterValue.LLM, virtualPath: 'llm', name: 'LL.M. Master of Laws', shortName: 'LL.M.', portalTypes: [PortalType.MASTER] },
		{ id: DegreeTypeFilterValue.MPHIL, virtualPath: 'mphil', name: 'M.Phil. Master of Philosophy', shortName: 'M.Phil.', portalTypes: [PortalType.MASTER] },
		{ id: DegreeTypeFilterValue.MLITT, virtualPath: 'mlitt', name: 'M.Litt. Master of Letters', shortName: 'M.Litt.', portalTypes: [PortalType.MASTER] },
		{ id: DegreeTypeFilterValue.MRES, virtualPath: 'mres', name: 'M.Res. Master of Research', shortName: 'M.Res.', portalTypes: [PortalType.MASTER]},
		{ id: DegreeTypeFilterValue.MED, virtualPath: 'med', name: 'M.Ed. Master of Education', shortName: 'M.Ed.', portalTypes: [PortalType.MASTER] },
		{ id: DegreeTypeFilterValue.MENG, virtualPath: 'meng', name: 'M.Eng. Master of Engineering', shortName: 'M.Eng.', portalTypes: [PortalType.MASTER] },
		{ id: DegreeTypeFilterValue.POSTGRADIP, virtualPath: 'postgraduate-diploma', name: 'Postgraduate Diploma', portalTypes: [PortalType.MASTER] },
		{ id: DegreeTypeFilterValue.POSTGRADCERT, virtualPath: 'postgraduate-certificate', name: 'Postgraduate Certificate', portalTypes: [PortalType.MASTER] },
		{ id: DegreeTypeFilterValue.PREMASTER, virtualPath: 'pre-master', name: 'Pre-Master', portalTypes: [PortalType.MASTER] },

		{ id: DegreeTypeFilterValue.BSC, virtualPath: 'bsc', name: 'B.Sc. Bachelor of Science', shortName: 'B.Sc.', portalTypes: [PortalType.BACHELOR] },
		{ id: DegreeTypeFilterValue.BA, virtualPath: 'ba', name: 'B.A. Bachelor of Arts', shortName: 'B.A.', portalTypes: [PortalType.BACHELOR]  },
		{ id: DegreeTypeFilterValue.BBA, virtualPath: 'bba', name: 'B.B.A. Bachelor of Business Administration', shortName: 'B.B.A.', portalTypes: [PortalType.BACHELOR]  },
		{ id: DegreeTypeFilterValue.LLB, virtualPath: 'llb', name: 'L.L.B. Bachelor of Laws', shortName: 'L.L.B.', portalTypes: [PortalType.BACHELOR] },
		{ id: DegreeTypeFilterValue.BENG, virtualPath: 'beng', name: 'B.Eng. Bachelor of Engineering', shortName: 'B.Eng.', portalTypes: [PortalType.BACHELOR] },
		{ id: DegreeTypeFilterValue.ASSOCIATE_DEGREE, virtualPath: 'associate-degree', name: 'Associate Degree', portalTypes: [PortalType.BACHELOR]  },
		{ id: DegreeTypeFilterValue.ACADEMY_PROFESSION, name: 'Academy Profession', portalTypes: [PortalType.BACHELOR]},
		{ id: DegreeTypeFilterValue.GRADUATE_CERTTIFICATE, virtualPath: 'graduate-certificate', name: 'Graduate Certificate', portalTypes: [PortalType.BACHELOR]  },
		{ id: DegreeTypeFilterValue.GRADUATE_DIPLOMA, virtualPath: 'graduate-diploma', name: 'Graduate Diploma', portalTypes: [PortalType.BACHELOR]  },
		{ id: DegreeTypeFilterValue.PREBACHELOR, virtualPath: 'prebachelor', name: 'Pre-Bachelor', portalTypes: [PortalType.BACHELOR]  },
		{ id: DegreeTypeFilterValue.ADVANCED_DIPLOMA, virtualPath: 'adiploma', name: 'Advanced diploma', portalTypes: [PortalType.BACHELOR, PortalType.SHORT]},

		{ id: DegreeTypeFilterValue.PHD, virtualPath: 'ph-d', name: 'Ph.D', portalTypes: [PortalType.PHD]   },
		{ id: DegreeTypeFilterValue.DBA, virtualPath: 'dba', name: 'D.B.A', portalTypes: [PortalType.PHD] },
		{ id: DegreeTypeFilterValue.DOCTORATE, virtualPath: 'doctorate', name: 'Doctorate', portalTypes: [PortalType.PHD] },

		{ id: DegreeTypeFilterValue.CERTIFICATE, virtualPath: 'certificate', name: 'Certificate', portalTypes: [PortalType.SHORT] },
	];

	public static getInstance(): DegreeTypeFilterMapper {
		if (!DegreeTypeFilterMapper.instance) {
			DegreeTypeFilterMapper.instance = new DegreeTypeFilterMapper();
		}
		return DegreeTypeFilterMapper.instance;
	}

	private constructor() {
		super();
	}

	public override allowedInSearchType(searchType?: SearchType): boolean {
		return searchType === SearchType.PROGRAMME_SEARCH;
	}
}
